import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { GET_BOOKING_DUMP_TYPE_LIST, GET_BOOKING_DUMP_TYPE_LIST_SUCCESS, GET_BOOKING_DUMP_TYPE_LIST_ERROR } from '../actions';
import apiCall from '../../apiCall';

function* getBookingDumpTypeList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/downloads/booking-dump-type-list`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_DUMP_TYPE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_DUMP_TYPE_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_DUMP_TYPE_LIST_ERROR, payload: error });
  }
}

export function* watchBookingDumpTypeList() {
  yield takeEvery(GET_BOOKING_DUMP_TYPE_LIST, getBookingDumpTypeList);
}

function* bookingDumpTypeListSaga() {
  yield all([fork(watchBookingDumpTypeList)]);
}

export default bookingDumpTypeListSaga;
